module.exports = "/_next/static/images/a304891247a97af7002764f102ce4007-phone-and-card@sm-2x.jpg.webp";